<div class="card mb-4">
  <div class="card-header py-2 d-flex justify-content-between align-items-center">
    <h6 class="mb-0">Subscriptions</h6>
    @if (canAdd()) {
      <button
        type="button"
        class="btn btn-sm btn-primary"
        (click)="openAddDialog()"
      >+ Add Subscription</button>
    }
  </div>
  <div class="card-body p-0">
    @if (isLoading()) {
      <div class="d-flex justify-content-center py-4">
        <div
          class="spinner-border text-secondary"
          role="status"
        >
          <span class="visually-hidden">Loading subscriptions...</span>
        </div>
      </div>
    } @else if (products().length === 0) {
      <div class="text-muted text-center py-4">No subscriptions for this organization.</div>
    } @else {
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead>
            <tr>
              <th>Product</th>
              <th>SKU</th>
              <th>Billing Element</th>
              <th>Status</th>
              <th class="text-end">Contracted Count</th>
              <th class="text-end">Base Rate</th>
              <th class="text-end">Exception Rate</th>
              <th>Exception</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (product of products(); track product.id) {
              <tr>
                <td>{{ product.product_name }}</td>
                <td>{{ product.sku }}</td>
                <td>{{ product.billing_element }}</td>
                <td>
                  @if (editingProductId() === product.id && isCustomerSubscription(product)) {
                    <select
                      class="form-select form-select-sm w-auto"
                      [formControl]="editStatus"
                    >
                      @for (s of statusOptions; track s) {
                        <option [value]="s">{{ s | titlecase }}</option>
                      }
                    </select>
                  } @else if (product.status) {
                    <span
                      class="badge text-capitalize"
                      [class.bg-success]="product.status === 'active'"
                      [class.bg-info]="product.status === 'scheduled'"
                      [class.bg-secondary]="product.status === 'expired'"
                      [class.bg-danger]="product.status === 'cancelled'"
                    >{{ product.status }}</span>
                  } @else {
                    <span class="text-muted">—</span>
                  }
                </td>
                <td class="text-end">
                  @if (editingProductId() === product.id) {
                    <input
                      type="number"
                      min="0"
                      step="1"
                      class="form-control form-control-sm text-end"
                      [formControl]="contractedCount"
                    />
                  } @else {
                    {{ product.contracted_count | number }}
                  }
                </td>
                <td class="text-end">
                  {{ product.base_rate | currency: product.currency : 'symbol' : '1.2-2' }}
                </td>
                <td class="text-end">
                  @if (product.exception_rate !== null && product.exception_rate !== undefined) {
                    {{ product.exception_rate | currency: product.currency : 'symbol' : '1.2-2' }}
                  } @else {
                    <span class="text-muted">—</span>
                  }
                </td>
                <td>
                  @if (product.has_pricing_exception) {
                    <span class="badge bg-warning text-dark">Discounted</span>
                  } @else {
                    <span class="text-muted">—</span>
                  }
                </td>
                <td class="text-end">
                  <div class="d-flex gap-1 justify-content-end align-items-center">
                    @if (editingProductId() === product.id) {
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        (click)="saveEdit(product)"
                      >Save</button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        (click)="cancelEdit()"
                      >Cancel</button>
                    } @else {
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        [disabled]="editingProductId() !== null"
                        (click)="startEdit(product)"
                      >Edit</button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

@if (showAddDialog()) {
  <app-add-subscription-dialog
    [products]="subscribableProducts()"
    [saving]="savingSubscription()"
    (add)="onAddSubscription($event)"
    (close)="closeAddDialog()"
  ></app-add-subscription-dialog>
}
